(function () {
  'use strict';

  var SELECTOR = '[data-collection-card-gallery]';

  function initGallery(gallery) {
    if (gallery.dataset.galleryInitialized === 'true') return;

    var track = gallery.querySelector('[data-gallery-track]');
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var previousButton = gallery.querySelector('[data-gallery-previous]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');

    if (!track || slides.length < 2) return;

    gallery.dataset.galleryInitialized = 'true';
    var activeIndex = 0;
    var scrollTimer;
    var pointerStartX = 0;
    var pointerMoved = false;
    var desktopNavigationStarted = false;

    function update(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));

      if (previousButton) previousButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;

      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === activeIndex);
      });
    }

    function goTo(index) {
      var target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      update(index);
    }

    if (previousButton) {
      previousButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(activeIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(activeIndex + 1);
      });
    }

    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var width = track.clientWidth;
        if (width) update(Math.round(track.scrollLeft / width));
      }, 60);
    }, { passive: true });

    track.addEventListener('pointerdown', function (event) {
      pointerStartX = event.clientX;
      pointerMoved = false;
    }, { passive: true });

    track.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientX - pointerStartX) > 8) pointerMoved = true;
    }, { passive: true });

    // Navigate on mouse release, before desktop theme card handlers get a
    // chance to cancel the subsequent click event.
    track.addEventListener('pointerup', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      if (Math.abs(event.clientX - pointerStartX) > 8) pointerMoved = true;
      if (pointerMoved) return;

      var productLink = event.target.closest('[data-gallery-slide]');
      if (!productLink || !track.contains(productLink)) return;

      // Let the browser handle Ctrl/Cmd/Shift-click in the normal way.
      if (
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      desktopNavigationStarted = true;
      event.preventDefault();
      event.stopPropagation();
      window.location.href = productLink.href;
    });

    track.addEventListener('click', function (event) {
      if (desktopNavigationStarted) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (pointerMoved) {
        event.preventDefault();
        event.stopPropagation();
        pointerMoved = false;
        return;
      }

      var productLink = event.target.closest('[data-gallery-slide]');
      if (!productLink || !track.contains(productLink)) return;

      // Keep the theme's desktop card/quick-shop handlers from swallowing the
      // image link. Modified clicks retain the browser's normal new-tab action.
      event.stopPropagation();

      if (
        event.button === 0 &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey &&
        !event.altKey
      ) {
        event.preventDefault();
        window.location.assign(productLink.href);
      }
    }, true);

    update(0);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(initGallery);

    if (scope.matches && scope.matches(SELECTOR)) initGallery(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Supports product cards inserted by collection filtering or infinite scroll.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) initAll(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();